import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import noop from 'lodash/noop';

import {
    DENTAL_INSURANCE_SPECIALTIES,
    VISION_INSURANCE_SPECIALTIES,
    INSURANCE_TYPES,
} from '@zocdoc-frontend-common/utils-react';

import { CARRIER, IM_PAYING_MYSELF_CAPITALIZED_TEXT } from '../../constants';
import InsurancePropTypes from '../../InsurancePropTypes';
import BlueCrossBlueShieldModal from '../BlueCrossBlueShieldModal';
import InsuranceCarrierDropdown from '../InsuranceCarrierDropdown';
import InsurancePlanDropdown from '../InsurancePlanDropdown';

class InsuranceForm extends Component {
    static propTypes = {
        carrierId: PropTypes.string,
        imPayingMyselfText: PropTypes.string,
        insuranceType: InsurancePropTypes.insuranceType,
        onChangeCarrier: PropTypes.func.isRequired,
        onClickCarrier: PropTypes.func,
        onChangePlan: PropTypes.func.isRequired,
        onClickPlan: PropTypes.func,
        planId: PropTypes.string,
        specialtyId: PropTypes.string,
    };

    static defaultProps = {
        carrierId: CARRIER.IM_PAYING_MYSELF,
        imPayingMyselfText: IM_PAYING_MYSELF_CAPITALIZED_TEXT,
        insuranceType: INSURANCE_TYPES.HEALTH,
        onClickCarrier: noop,
        onClickPlan: noop,
    };

    render() {
        const { carrierId } = this.props;

        if (carrierId === CARRIER.IM_PAYING_MYSELF) {
            return this.renderCarrierDropdown();
        } else if (carrierId === CARRIER.BLUE_CROSS_BLUE_SHIELD) {
            return (
                <div>
                    {this.renderCarrierDropdown()}
                    {this.renderBlueCrossBlueShieldModal()}
                </div>
            );
        }

        return (
            <div>
                <div>{this.renderCarrierDropdown()}</div>

                <Plan>{this.renderPlanDropdown()}</Plan>
            </div>
        );
    }

    renderCarrierDropdown() {
        const {
            carrierId,
            imPayingMyselfText,
            insuranceType,
            onChangeCarrier,
            onClickCarrier,
            specialtyId,
        } = this.props;

        return (
            <InsuranceCarrierDropdown
                carrierId={carrierId}
                imPayingMyselfText={imPayingMyselfText}
                insuranceType={this.getInsuranceType(
                    specialtyId,
                    insuranceType
                )}
                onChange={onChangeCarrier}
                onClick={onClickCarrier}
            />
        );
    }

    renderPlanDropdown() {
        const { carrierId, onChangePlan, onClickPlan, planId } = this.props;

        return (
            <InsurancePlanDropdown
                carrierId={carrierId}
                onChange={onChangePlan}
                onClick={onClickPlan}
                planId={planId}
            />
        );
    }

    renderBlueCrossBlueShieldModal() {
        const { onChangeCarrier } = this.props;

        return <BlueCrossBlueShieldModal onChange={onChangeCarrier} />;
    }

    getInsuranceType(specialtyId, insuranceType) {
        if (specialtyId) {
            if (DENTAL_INSURANCE_SPECIALTIES.has(specialtyId)) {
                return INSURANCE_TYPES.DENTAL;
            } else if (VISION_INSURANCE_SPECIALTIES.has(specialtyId)) {
                return INSURANCE_TYPES.VISION;
            } else {
                return INSURANCE_TYPES.HEALTH;
            }
        } else {
            return insuranceType;
        }
    }
}

const Plan = styled.div`
    margin-top: 12px;
`;

export {
    InsuranceForm,
    DENTAL_INSURANCE_SPECIALTIES,
    VISION_INSURANCE_SPECIALTIES,
};
